/* eslint-disable linebreak-style */
import './_fitment-table.scss';

const toggleTableRows = (section) => {
    section.classList.toggle('table-section--open');
    
    const tableRows = section.querySelectorAll('tr');
    const tableButton = section.querySelector('.button');
    const tableOpen = section.classList.contains('table-section--open');

    tableRows.forEach((row, index) => {
        row.style.display = !tableOpen && index >= 5 ? 'none' : 'flex';
    });

    tableButton.innerHTML = tableOpen ? 'Show Less' : 'Show More';
};

document.addEventListener('DOMContentLoaded', function() {
    const tableSections = document.querySelectorAll('.table-section');

    tableSections.forEach((section) => {
        const tableButton = section.querySelector('.button');
        
        if (tableButton) {
            tableButton.addEventListener('click', () => toggleTableRows(section));
        }
    });
});

// Function to get URL parameters
function getUrlParams() {
    let params = {};
    let parser = new URLSearchParams(window.location.search);
    for (let param of parser.entries()) {
        params[param[0].toLowerCase()] = param[1];
    }
    return params;
}

// Function to dynamically map columns and highlight the row
function highlightRow(table) {
    let params = getUrlParams();
    
    // Check if there are any parameters in the URL
    if (Object.keys(params).length === 0) {
        return; // Exit the function if there are no parameters
    }

    let headerRow = table.getElementsByTagName('tr')[0];
    let headerCells = headerRow.getElementsByTagName('th');
    let paramToColumnIndex = {};

    // Dynamically create the parameter-to-column index map
    for (let i = 0; i < headerCells.length; i++) {
        let headerText = headerCells[i].innerText.toLowerCase().replace(/\s+/g, '_');
        paramToColumnIndex[headerText] = i;
    }

    let rows = table.getElementsByTagName('tr');

    for (let i = 1; i < rows.length; i++) { // Start from 1 to skip header row
        let cells = rows[i].getElementsByTagName('td');
        let match = true;
        
        for (let param in params) {
            let paramKey = param.toLowerCase().replace(/\s+/g, ''); // Remove spaces from parameter key

            if (paramToColumnIndex.hasOwnProperty(paramKey)) {
                let cellText = cells[paramToColumnIndex[paramKey]].innerText.toLowerCase().trim(); // Trim whitespace
                let paramValue = params[param].toLowerCase().trim(); // Trim whitespace
                
                if (cellText !== paramValue) {
                    match = false;
                    break;
                }
            }
        }

        if (match) {
            rows[i].style.color = '#000'; // Change text to black
            rows[i].style.fontWeight = '600'; // Highlighting the row

            // Apply styles to each cell in the matched row
            for (let j = 0; j < cells.length; j++) {
                cells[j].style.backgroundColor = '#FA6400'; // Highlighting the cells
            }
        }
    }
}

// Call the highlightRow function on page load
document.addEventListener('DOMContentLoaded', () => {
    const fitmentTable = document.getElementById('fitmentTable');

    if (fitmentTable) {
        highlightRow(fitmentTable);
    }
});